export const SpinnerType = {
  Overlay: 'overlay',
  Standart: 'standart'
};
